<template>
	<div class="d-flex flex-column">
		<ao-checkboxes-collapse
			v-for="(item, idx) in items"
			class="collapse_group"
			:model-value="item.checkboxSelected"
			:items="item.checkboxItems"
			:model-mainItem="item.mainItemSelected"
			:mainItem="item.mainItem"
			:item-title="item.itemTitle"
			:item-value="item.itemValue"
			:returnObject="item.returnObject"
			:isShowSelectAll="item.isShowSelectAll"
			:isSearch="item.isSearch"
			@update:modelValue="$emit('groupItemUpdate', { key: $event, index: idx })"
			@update:modelMainItem="$emit('groupUpdate', { key: $event, index: idx })"
		/>
	</div>
</template>

<script>
export default {
    name: 'AoCheckboxesCollapseList',

    props: {
        items: {
            type: Array,
            default: () => [],
        },
        divider: {
            type: Boolean,
            default: false
        },
    },

    emits: ['groupUpdate', 'groupItemUpdate'],

    methods: {
        genKey: (i) => `salt-${i}:` + Math.random()
    }
}
</script>

<style lang="scss">
.collapse_group {
    border-top: 1px solid #E9EAEA;

    &:last-child {
        border-bottom: 1px solid #E9EAEA;
    }
}
</style>
